export default __webpack_public_path__ + "static/media/tvscientific-logo.112f2da4.png";